/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M480 0c17.597 0 32 14.405 32 32v448c0 17.592-14.402 32-32 32H32c-17.593 0-32-14.408-32-32V32C0 14.405 14.407 0 32 0zM250.517 168.27c-16.496-.12-30.557.07-38.462 3.962-5.264 2.572-9.346 8.35-6.842 8.66 3.087.445 9.98 1.885 13.684 6.893 4.599 6.302 4.585 20.01 4.579 20.97v.053s2.709 40.04-6.397 44.995c-6.276 3.327-14.815-3.584-33.25-35.393-9.413-16.307-16.564-34.312-16.564-34.312s-1.389-3.327-3.824-5.162c-3.018-2.194-7.167-2.88-7.167-2.88l-44.035.308s-6.585.189-9.037 3.087c-2.195 2.572-.189 7.836-.189 7.836s34.57 80.697 73.53 121.286c35.89 37.33 76.546 34.878 76.546 34.878h18.458c.22-.026 5.64-.68 8.395-3.704 2.408-2.633 2.517-7.43 2.521-8.031v-.07c-.006-.485-.262-24.739 11.095-28.338 11.3-3.515 25.79 23.904 41.223 34.501 11.677 8.025 20.525 6.276 20.525 6.276l41.155-.565s21.589-1.32 11.42-18.383c-.823-1.389-5.967-12.552-30.626-35.444-25.841-24.04-22.394-20.148 8.729-61.56 18.948-25.276 26.544-40.726 24.16-47.31-2.263-6.276-16.187-4.63-16.187-4.63l-46.367.308s-3.395-.445-5.967 1.064c-2.453 1.44-4.082 4.955-4.082 4.955s-7.339 19.583-17.13 36.199c-20.697 35.084-28.911 36.953-32.306 34.758-7.837-5.007-5.899-20.388-5.899-31.243 0-34.004 5.144-48.185-10.031-51.82-5.025-1.2-8.729-2.006-21.658-2.143z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconVk = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconVk.defaultProps = {
  theme,
};
IconVk.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconVk.displayName = 'IconVk';
export { IconVk };
